// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_kq-1";
export var quotedThread = "_kq-0";